
import { SuccessComponent } from '@src/components/SuccessComponent';
import { useFormLogic } from '@src/hooks/useFormLogicWithReducer';
import { useDemoFormValidation } from '@src/hooks/useFormValidation';
import { useNavigateToTop } from '@src/hooks/useNavigateToTop';
import { useCsrfFormSecurity } from '@src/plugins/cookies';

import { DemoForm } from './DemoForm';

// 1. Unique Definitions
const DEMO_INITIAL_STATE = {
  first_name: '',
  last_name: '',
  email: '',
  company: '',
  industry: '-',
  company_size: '-',
  modules_of_interest: '',
  recaptchaToken: '',
};
const DEMO_ENDPOINT = 'api/v1/contacts/demo/submission/';

const nextStep = 1;
const scrollToTop = true;


export default function Demo() {

  const csrfHookInfo = useCsrfFormSecurity();
  const onNavigateToTop = useNavigateToTop();

  // --- ONE SINGLE HOOK CALL replaces all state, inputs, mutation, and submission logic ---
  const {
    currentStep,
    recaptchaError,
    setRecaptchaError,
    setRecaptchaResetFunc,
    submissionStatus,
    setSubmissionStatus,
    formData,
    handleInputChange,
    mutation,
    errors,
    handleSubmit,
    clearError,
  } = useFormLogic(
    DEMO_INITIAL_STATE,
    DEMO_ENDPOINT,
    useDemoFormValidation,
    csrfHookInfo,
    nextStep,
    scrollToTop,
  );
  // --------------------------------------------------------------------------------------

  const { title, subtitle, nextSteps } = {
    title: 'Your BOSSS Demo Is Scheduled!',
    subtitle: 'Thanks for your interest! A member of our cybersecurity team will contact you within one business day to confirm your demo session.',
    nextSteps: [
      'Check your email for confirmation details',
      'Our team will reach out to schedule your personalized demo',
      'Prepare any questions you have about BOSSS capabilities',
    ],
  };

  return (
    <div className="py-20 bg-gradient-to-br from-blue-50 via-white to-blue-50">
      {currentStep === 0 && DemoForm({
        onNavigateToTop,
        submissionStatus,
        setSubmissionStatus,
        recaptchaError,
        setRecaptchaError,
        csrfHookInfo,
        formData,
        handleInputChange,
        mutation,
        errors,
        setRecaptchaResetFunc,
        handleSubmit,
        clearError})}

      {currentStep === 1 && <SuccessComponent title={title} confetti={true} subtitle={subtitle} nextSteps={nextSteps} />}
    </div>
  );
}
